import React, { memo } from 'react';
import { PenToolIcon, SearchIcon, BookOpenIcon, InstagramIcon, TypeIcon, HeartIcon, TvIcon, UserIcon } from 'lucide-react';
import { ServiceCard } from '../components/ServiceCard';
export function Services() {
  const services = [{
    title: 'Brand Storytelling for Campaigns',
    description: "We craft campaign narratives that move people. Whether you're launching a new product, repositioning your brand, or engaging your audience, we help you articulate your story in a way that sticks.",
    deliverables: ['Campaign narratives', 'Press releases & media briefs', 'Product launch scripts', 'Brand manifestos'],
    icon: <PenToolIcon size={32} className="text-gray-900" data-id="element-1353" />
  }, {
    title: 'SEO Website Content',
    description: "Content that ranks without losing its voice. We write for real humans - and optimize for search engines. Whether it's your homepage, about page, or service descriptions, we make sure your content is both discoverable and persuasive.",
    deliverables: ['Website copywriting (SEO-optimized)', 'Product/service descriptions', 'Landing pages', 'Meta tags & search previews'],
    icon: <SearchIcon size={32} className="text-gray-900" data-id="element-1354" />
  }, {
    title: 'Blog & Editorial Writing',
    description: "We help you become a thought leader in your niche. Our blog content is sharp, relevant, and rooted in local context. We've ghostwritten for top-ranking blogs across fintech, lifestyle, finance, government, sports and education.",
    deliverables: ['Weekly/monthly blogs', 'Editorial articles', 'Guest posts & PR content', 'Thought leadership series'],
    icon: <BookOpenIcon size={32} className="text-gray-900" data-id="element-1355" />
  }, {
    title: 'Social Media Content & Management',
    description: "We craft content calendars that drive conversations. Whether you're after consistency, engagement, or campaign rollouts, we plan, create, and schedule content that speaks the language of your audience.",
    deliverables: ['Caption writing & visual direction', 'Social campaign content (organic & paid)', 'Hashtag strategies', 'Community engagement scripts'],
    icon: <InstagramIcon size={32} className="text-gray-900" data-id="element-1356" />
  }, {
    title: 'Creative Copywriting',
    description: 'We write with intent - and impact. From headlines to email campaigns, taglines to ad copy, we use language to create urgency, relevance, and brand affinity.',
    deliverables: ['Taglines & slogans', 'Ad copy (print, digital, social)', 'Email sequences', 'CTAs and hooks'],
    icon: <TypeIcon size={32} className="text-gray-900" data-id="element-1357" />
  }, {
    title: 'NGO & Government Content',
    description: "We bring clarity and human emotion to public sector storytelling. We've written for ministries, NGO initiatives, and government programs - helping communicate policies, projects, and impact stories.",
    deliverables: ['Public service announcements', 'Policy storytelling & summaries', 'Community feature stories', 'Awareness campaign content'],
    icon: <HeartIcon size={32} className="text-gray-900" data-id="element-1358" />
  }, {
    title: 'Advertising & Brand Campaigns',
    description: "We create ads that connect - not just impress. From visual storytelling to short-form commercials, we develop native-style ad content that's bold, relevant, and results-oriented.",
    deliverables: ['Video ads (scriptwriting, concepting & coordination)', 'Sponsored content scripts', 'Social ads & performance messaging', 'Out-of-home campaign concepts', 'Voiceovers & visual direction support'],
    icon: <TvIcon size={32} className="text-gray-900" data-id="element-1359" />
  }, {
    title: 'Professional Biography Writing',
    description: "Your story deserves more than a summary - it deserves to be told with clarity, purpose, and power. We don't just list achievements - we craft compelling stories that position you as credible, inspiring, and unforgettable.",
    deliverables: ['Executive and corporate bios', 'Political profiles and campaign narratives', 'Founder/entrepreneur brand stories', 'Artist and creator spotlights', 'Full-length memoirs or legacy storytelling (upon request)'],
    icon: <UserIcon size={32} className="text-gray-900" data-id="element-1360" />
  }];
  return <div className="w-full" data-id="element-1361">
      {/* Header */}
      <section className="cream-bg py-16 md:py-24 w-full" data-id="element-1362">
        <div className="container mx-auto px-4" data-id="element-1363">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1364">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 elegant-heading" data-id="element-1365">
              Our Services
            </h1>
            <div className="elegant-divider" data-id="element-1366"></div>
            <p className="text-xl navy-text" data-id="element-1367">
              At Muthamia Content, we help brands speak with clarity,
              confidence, and authenticity - across formats and platforms.
            </p>
            <p className="text-gray-700 mt-4" data-id="element-1368">
              Every service we offer is driven by a deep understanding of local
              culture, audience behavior, and strategic communication.
            </p>
          </div>
        </div>
      </section>
      {/* Services List */}
      <section className="py-16 w-full bg-white" data-id="element-1369">
        <div className="container mx-auto px-4" data-id="element-1370">
          <h2 className="text-3xl font-bold mb-12 text-center elegant-heading accent-color" data-id="element-1371">
            Here's what we excel at:
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1372">
            {services.map((service, index) => <ServiceCard key={index} title={service.title} description={service.description} deliverables={service.deliverables} icon={service.icon} data-id="element-1373" />)}
          </div>
        </div>
      </section>
    </div>;
}